module.exports = __webpack_public_path__ + "static/media/1990s-Phone-Icon.f90b09a7.png";